
export default {
  props: {
    links: {
      type: Array,
      required: true,
    },

    activeLink: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isDropdownOpen: false,
    }
  },

  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    },

    closeDropdown() {
      this.isDropdownOpen = false
    },

    beforeEnter(el) {
      el.style.opacity = '0'
      el.style.height = '0'
    },

    enter(el) {
      el.style.height = el.scrollHeight + 'px'
    },

    afterEnter(el) {
      el.style.opacity = '1'
    },

    beforeLeave(el) {
      el.style.opacity = '1'
      el.style.height = el.scrollHeight + 'px'
    },

    leave(el) {
      el.style.opacity = '0'
      el.style.height = '0'
    },
  },
}
